import { useEffect } from 'react';
import { Siren, Star, X } from '@phosphor-icons/react';
import { useToastStore } from '../alerts';
import { useStore } from '../state/store';

const AUTO_DISMISS_MS = 8000;

function Toast({ id, icao24, message, kind, sticky }: { id: string; icao24: string; message: string; kind: string; sticky: boolean }) {
  const dismiss = useToastStore((s) => s.dismiss);
  const select = useStore((s) => s.select);

  useEffect(() => {
    if (sticky) return;
    const t = setTimeout(() => dismiss(id), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [id, sticky, dismiss]);

  const emergency = kind === 'emergency';

  return (
    <li className={`toast toast-${kind} glass`} role={emergency ? 'alert' : 'status'}>
      <button
        className="toast-body"
        onClick={() => {
          select(icao24);
          dismiss(id);
        }}
        title="Show this flight"
      >
        <span className="toast-icon" aria-hidden="true">
          {emergency ? <Siren size={16} weight="fill" /> : <Star size={16} weight="fill" />}
        </span>
        <span className="toast-text">
          <span className="toast-kind">{emergency ? 'Emergency squawk' : 'Watchlist'}</span>
          <span className="toast-message">{message}</span>
        </span>
      </button>
      <button
        className="icon-btn sm toast-close"
        aria-label="Dismiss"
        onClick={() => dismiss(id)}
      >
        <X size={13} weight="bold" />
      </button>
      {!sticky && <span className="toast-timer" style={{ animationDuration: `${AUTO_DISMISS_MS}ms` }} aria-hidden="true" />}
    </li>
  );
}

export default function ToastStack() {
  const toasts = useToastStore((s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <ul className="toast-stack" aria-live="polite">
      {toasts.map((t) => (
        <Toast key={t.id} {...t} />
      ))}
    </ul>
  );
}
